import * as React from 'react';
import styled, { css } from 'styled-components';

type Props = {
    show: boolean;
};

const Overlay = ({ show }: Props) => {
    return show && <StyledOverLay $shouldShow={show} />;
};

Overlay.defaultProps = {
    show: false,
};

export default React.memo<Props>(Overlay);

const StyledOverLay = styled.div<{ $shouldShow?: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.shadowOverlay300};
    z-index: 10;
    transition: opacity 300ms ease-in-out;
    opacity: 0;
    ${({ $shouldShow }) => {
        if ($shouldShow) {
            return css`
                transition: opacity 300ms ease-in-out;
                opacity: 1;
            `;
        }
    }}
`;
